import { useEffect } from "react";

export default function Toast({ message, type = "error", onClose }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, 5000);
    return () => clearTimeout(t);
  }, [message, onClose]);

  if (!message) return null;

  const colors = {
    error: "bg-red-600",
    success: "bg-green-600",
  };

  return (
    <div className={`fixed top-4 right-4 z-50 flex items-start gap-3 max-w-sm rounded-lg shadow-lg px-4 py-3 text-white text-sm ${colors[type]}`}>
      <span className="flex-1">{message}</span>
      <button onClick={onClose} className="shrink-0 opacity-80 hover:opacity-100 text-lg leading-none mt-[-2px]">×</button>
    </div>
  );
}
